import { errors } from '@feathersjs/client';
function getSubdomainFromRule(paymentTier, subdomain) {
    var pTier = Number(paymentTier);
    var output = subdomain.toLowerCase();
    if (isNaN(pTier)) {
        throw new errors.BadRequest('Payment Tier is invalid');
    }
    if (pTier === 0 && output.indexOf('free-') !== 0) {
        output = "free-" + output;
    }
    return output;
}
export default getSubdomainFromRule;



//////////////////
// WEBPACK FOOTER
// ./src/imports/getSubdomainFromRule.ts
// module id = 425
// module chunks = 0